import { cx } from '@/utils/cx';
import styles from './Skeleton.module.scss';

export interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  borderRadius?: number | string;
  className?: string;
}

export function Skeleton({ width = '100%', height = 16, borderRadius, className }: SkeletonProps) {
  return (
    <span
      className={cx(styles.block, className)}
      style={{ width, height, borderRadius }}
      aria-hidden="true"
    />
  );
}

export interface CardSkeletonProps {
  variant?: 'grid' | 'featured';
}

export function CardSkeleton({ variant = 'grid' }: CardSkeletonProps) {
  return (
    <div
      className={cx(styles.block, styles.card, variant === 'featured' ? styles.cardFeatured : styles.cardGrid)}
      aria-hidden="true"
    />
  );
}

export function RowSkeleton() {
  return <div className={cx(styles.block, styles.row)} aria-hidden="true" />;
}
